<template>
  <!-- s::PAGE -->
  <div v-if="loading" class="loading"></div>

  <div v-else-if="error" class="error">{{ error.message }}</div>

  <div v-else class="contents">
    <!-- s:: ARTICLE -->
    <div class="article">
      <div class="layout">
        <div class="box">
          <ArticleSnb/>
          <div class="content-panel">
            <div class="search-wrap">
              <ArticleStatusFilter
                  :selected-status="articleStatus"
                  @update:selectedStatus="handleStatusChange"
              />
              <SearchBar v-model="searchQuery" :placeholder="placeholder" @submit="onSearch"/>
            </div>
            <div v-if="items.length" class="list-type1 exhibition">
              <ul>
                <li v-for="(item, index) in items" :key="index">
                  <ArticleCard v-model:isLike="item.isLike" :item="item" :to="{ name: Detail, params: { uuid: item.uuid } }" />
                  <!--
                  <a @click="beforeNavigate({ name: Detail, params: { uuid: item.uuid } })">
                    <ArticleCard v-model:isLike="item.isLike" :item="item"  />
                  </a>
                  -->
                </li>
              </ul>
            </div>
            <NoSearchResult v-else/>
            <Pagination :current-page="currentPage" :total-pages="totalPages"
                        :visible-count="5" @goToPage="goToPage"/>
            <InfiniteScroll :on-reach-end="moreData" :current-page="currentPage"
                            :total-pages="totalPages" :is-fetching="isFetching"/>
          </div>
        </div>
      </div>
    </div>
    <!-- e:: ARTICLE -->
  </div>
  <!-- e::PAGE -->
</template>

<script setup>
import {computed, onMounted, ref, watch} from "vue";
import {useRoute} from "vue-router";
import router from "@/router";
import {apiClient} from "@/services/auth-header";
import ArticleSnb from "@/components/snb/ArticleSnb.vue";
import SearchBar from "@/components/ui/SearchBar.vue";
import Pagination from "@/components/ui/Pagination.vue";
import InfiniteScroll from "@/components/ui/InfiniteScroll.vue";
import ArticleCard from "@/components/article/ArticleCard.vue";
import NoSearchResult from "@/components/ui/NoSearchResult.vue";
import {ARTICLE_LIST_SORT_OPTIONS} from "@/common/common-enum";
import {useUiStore} from "@/store/useUiStore";
import ArticleStatusFilter from "@/components/article/ArticleStatusFilter.vue";
import {useDeviceStore} from "@/store/deviceStore";

const deviceStore = useDeviceStore();
const isMobile = computed(() => deviceStore.isMobile);

const uiStore = useUiStore();
const route = useRoute();
const loading = ref(true);
const error = ref(null);
const items = ref([]);
const Detail = computed(() => {
  return route.name ? route.name + 'Detail' : '';
});
const API_URL = '/v1/contents/articles/' + (route.name.toLowerCase().endsWith('s') ? route.name.toLowerCase() : route.name.toLowerCase() + 's');

// 페이지 정보
const articleStatus = ref(route.query.filter || 'ALL')
const searchQuery = ref(route.query.q || "");
const currentPage = ref(Number(route.query.page || 0));
const size = ref(20);
const totalPages = ref(0);
const isFetching = ref(false);
const selectedSort = ref({
  value: route.query.sort || ARTICLE_LIST_SORT_OPTIONS[0].value,
  direction: route.query.direction || ARTICLE_LIST_SORT_OPTIONS[0].direction
});


const placeholderMap = {
  'Exhibition': '전시명 또는 장소명',
  'Event': '행사명 또는 장소명',
  'News': '사업명 또는 기관명',
}

const placeholder = computed(() => placeholderMap[route.name] || '검색어를 입력하세요')

async function fetchItems(page = 0, append = false) {
  if (isFetching.value) {
    return;
  }
  isFetching.value = true;

  try {
    uiStore.showLoading();
    const response = await apiClient.get(API_URL, {
      params: {
        q: searchQuery.value,
        page: page,
        size: size.value,
        sort: selectedSort.value.value,
        direction: selectedSort.value.direction,
        filter: articleStatus.value
      }
    });

    const newData = response.data.content;

    if (append) {
      items.value.push(...newData);
    } else {
      items.value = newData;
    }

    currentPage.value = response.data.pageable.pageNumber;
    totalPages.value = response.data.totalPages;
  } catch (err) {
    error.value = err;
  } finally {
    isFetching.value = false;
    loading.value = false;
    uiStore.hideLoading();
  }
}

const beforeNavigate = async (to) => {
  // await router.push({
  //   name: route.name,
  //   query: {
  //     q: searchQuery.value,
  //     page: currentPage.value,
  //     sort: selectedSort.value.value,
  //     direction: selectedSort.value.direction,
  //     filter: articleStatus.value
  //   }
  // });
  await router.push(to);
};

async function goToPage(page = 0, append = false) {
  // 새로고침..
  await router.push({
    name: route.name,
    query: {q: searchQuery.value, page: page, sort: selectedSort.value.value, direction: selectedSort.value.direction, filter: articleStatus.value}
  });

  // 가끔에러..
  // const url = new URL(window.location.href);
  // url.searchParams.set("q", searchQuery.value);
  // url.searchParams.set("page", page);
  // url.searchParams.set("sort", selectedSort.value.value);
  // url.searchParams.set("direction", selectedSort.value.direction);
  // url.searchParams.set("filter", articleStatus.value);
  // window.history.pushState({goToPage: url.toString()}, "", url.toString());
  // await fetchItems(page, append);
}

function moreData(page = 0, append = false) {
  fetchItems(page, append);
}

function onSearch(query) {
  searchQuery.value = query;
  currentPage.value = 0;
  goToPage(0);
}

function handleStatusChange(newStatus) {
  articleStatus.value = newStatus
  goToPage(0);
}

onMounted(async () => {
  if (isMobile.value) {
    currentPage.value = 0;
  }

  await fetchItems(currentPage.value);

});

</script>
